import { UiService } from '../UiService';

export default class TestScreen {
    /**
     * TestScreen constructor
     * @param {UiService} uiService
     */
    constructor(uiService) {
        this.uiService = uiService;
    }

    display() {
        this.uiService.switchScreen('#test');

        document.body.classList.add('playing');
    }
}
